import React, { Component } from "react";
import moment from "moment-timezone";
import momentjalali from "moment-jalaali";
import Calendar from "./../asset/images/calendar.svg";
import Time from "./../asset/images/time.svg";
import { word } from "../words.js";
// import CustomButton from "../components/CustomButton";
import { Icon } from "@iconify/react";
import baselineAccessTime from "@iconify/icons-ic/baseline-access-time";
import cookingPotLight from "@iconify/icons-ph/cooking-pot-light";
import circleCheck from "@iconify/icons-akar-icons/circle-check";
import outlineCancel from "@iconify/icons-ic/outline-cancel";

export default class OrderItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: "",
      time: "",
      //   foods: "",
      businessName: "",
    };
  }

  componentDidMount() {
    var zone_name = moment.tz.guess();
    let newdatetime = moment
      .tz(this.props.datetime, zone_name)
      .format("yyyy-MM-DD HH:mm")
      .toString()
      .split(" ");
    newdatetime[0] = momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");

    let resname = "";

    for (let i = 0; i < this.props.item.businessNameObj.length; i++) {
      if (
        this.props.currentLang.languageId ===
        this.props.item.businessNameObj[i].languageId
      ) {
        resname = this.props.item.businessNameObj[i].name;
      }
    }
    if (!resname) resname = this.props.item.businessNameObj[0].name;

    this.setState({
      date: newdatetime[0],
      time: newdatetime[1],
      businessName: resname,
    });
  }

  onViewInvoiceClick() {
    this.props.onViewInvoiceClick(this.props.item.hashId);
  }

  render() {
    return (
      <div className="orderItem">
        <div className="orderLogo">
          <img
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            src={this.props.logo}
            alt=""
          />
        </div>
        <div
          className={
            this.props.currentLang.direction === "rtl"
              ? "orderItemContentContainer IRANSansMobileBoldFont"
              : "orderItemContentContainer SFUIDisplayBoldFont"
          }
          style={{
            marginLeft:
              this.props.currentLang.direction === "rtl" ? "0px" : "5px",
            marginRight:
              this.props.currentLang.direction === "rtl" ? "5px" : "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="OrderTitle">{this.state.businessName}</div>
              <div className="OrderDateTime">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img src={Calendar} alt="" className="orderItemTimeImg" />{" "}
                    {this.state.date}
                  </div>
                  <div style={{ margin: "0px 10px" }}>
                    <img src={Time} alt="" className="orderItemTimeImg" />
                    {this.state.time}
                  </div>
                </div>
              </div>
            </div>

            {(this.props.item.prepareStatusTitle ||
              this.props.item.statusTitle) && (
              <div
                style={{
                  border:
                    this.props.item.status !== 4 && this.props.item.status !== 5
                      ? "1px solid var(--brown1)"
                      : "1px solid var(--red1)",
                  color:
                    this.props.item.status !== 4 && this.props.item.status !== 5
                      ? "var(--brown1)"
                      : "var(--red1)",
                  borderRadius: "20px",
                  backgroundColor:
                    this.props.item.status !== 4 && this.props.item.status !== 5
                      ? "#ce835142"
                      : "#f73b4142",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "fit-content",
                  gap: "4px",
                  fontSize: "12px",
                }}
                className="prepareStatus"
              >
                <Icon
                  icon={
                    this.props.item.status === 1
                      ? baselineAccessTime
                      : this.props.item.status === 2
                      ? circleCheck
                      : this.props.item.status === 4 ||
                        this.props.item.status === 5
                      ? outlineCancel
                      : this.props.item.status === 6
                      ? baselineAccessTime
                      : cookingPotLight
                  }
                  width="16px"
                  height="16px"
                  // style={{ marginLeft: "5px" }}
                />
                {this.props.item.status !== 3
                  ? this.props.item.statusTitle
                  : this.props.item.prepareStatusTitle}
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
            className="sumPriceStyle"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "var(--brown1)",
              }}
            >
              {this.props.item.sum + " "}
              {this.props.currentLang.tag === "fa"
                ? this.props.item.priceUnitRTL
                : this.props.item.priceUnitLTR}
            </div>
            <div
              className="customButton sumPriceStyle"
              style={{
                backgroundColor: "transparent",
                color: "var(--brown1)",
                border: "2px solid var(--brown1)",
                width: "fit-content",
                whiteSpace: "nowrap",
              }}
              onClick={this.onViewInvoiceClick.bind(this)}
            >
              {word[this.props.currentLang.tag]["viewInvoice"]}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
